import { Link } from "react-router-dom";

export default function HomeHero() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Vibrant%20modern%20live%20streaming%20studio%20with%20colorful%20LED%20lighting%2C%20multiple%20screens%20displaying%20various%20streaming%20content%2C%20warm%20and%20energetic%20atmosphere%2C%20professional%20studio%20setup%20with%20festival-like%20decorations%2C%20pink%20and%20orange%20ambient%20glow%2C%20cinematic%20wide%20shot%2C%20editorial%20photography%20style%2C%20high%20quality%20with%20soft%20depth%20of%20field&width=1600&height=900&seq=hero-bg-candy-live&orientation=landscape"
        alt="糖果直播 - 直播资讯与内容平台"
        className="absolute inset-0 w-full h-full object-cover"
        title="糖果直播平台首页背景"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/55"></div>
      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4 md:px-6">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 md:mb-6" style={{ fontFamily: "var(--font-heading)" }}>
          糖果直播资讯平台
        </h1>
        <p className="text-base md:text-lg text-white/85 max-w-2xl mb-8 md:mb-10 leading-relaxed">
          汇聚最新直播资讯、精选栏目推荐、实用教程指南与平台动态，
          <br className="hidden md:block" />
          为用户提供便捷清晰的直播内容参考
        </p>
        <div className="flex flex-col sm:flex-row gap-4">
          <Link
            to="/category/zhibo-zixun"
            className="px-8 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            浏览资讯
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 bg-background-50/20 backdrop-blur-sm text-white border border-white/30 rounded-full text-sm font-semibold hover:bg-background-50/30 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            了解我们
          </Link>
        </div>
      </div>
    </section>
  );
}